import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { pasadenaConfig } from "./data";

export default function PasadenaPage() {
  return <CityPageTemplate config={pasadenaConfig} />;
}